import { gql, useQuery } from "@apollo/client";

//All Post
export const GET_POSTS = gql`
  query {
    blog_posts {
      id
      category
      title
      content
      date
      is_published
      author_id
    }
  }
`;
//Single Post
const GET_SINGLE_POST = gql`
  query singlePost($id: Int!) {
    blog_posts(where: { id: { _eq: $id } }) {
      title
      is_published
      content
      date
      category
      author_id
      id
    }
  }
`;
export const GetSinglePost = (id) => {
  const { data, error, loading } = useQuery(GET_SINGLE_POST, {
    variables: {
      id,
    },
  });
  return {
    data,
    error,
    loading,
  };
};

//filter by Category

export const GET_FILTERED_POST_BY_CATEGORY = gql`
  query filteredPost($category: String!) {
    blog_posts(where: { category: { _eq: $category } }) {
      id
      category
      title
      content
      date
      is_published
      author_id
    }
  }
`;
export const GetCategory = (category) => {
  const { data, error, loading } = useQuery(GET_FILTERED_POST_BY_CATEGORY, {
    variables: {
     category,
    },
  });
  return {
    data,
    error,
    loading,
  };
};
//filterby userid

export const GET_FILTERED_POST_BY_AUTHOR_ID = gql`
  query filteredPost($author_id: String!) {
    blog_posts(where: { author_id: { _eq: $author_id } }) {
      id
      category
      title
      content
      date
      is_published
      author_id
    }
  }
`;
export const GetUserPost = (author_id) => {
  const { data, error, loading } = useQuery(GET_FILTERED_POST_BY_AUTHOR_ID, {
    variables: {
      author_id,
    },
  });
  return {
    data,
    error,
    loading,
  };
};
// export const usePost = () => {
//   const { error, data, loading } = useQuery(GET_POSTS);
//   return {
//     error,data,loading
//   }
// };
export const INSERT_BLOG_POST = gql`
  mutation InsertBlogPost(
    $title: String!
    $content: String!
    $category: String!
    $author_id: String!
  ) {
    insert_blog_posts_one(
      object: {
        title: $title
        content: $content
        category: $category
        author_id: $author_id
      }
    ) {
      id
    }
  }
`;
